// NEW: UI_REVAMP
import { SearchIcon } from '@chakra-ui/icons';
import { Box, Flex, Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import {
	RECORD_GRADIENTS,
	RECORD_SHADOWS,
	RECORD_SURFACES,
	RECORD_TEXT_COLORS,
} from '../../styles/recordUiTokens';
import ImgComp from '../../utils/ImgComp';

const SearchFilterHeader = ({
	searchValue,
	placeholder = 'Search Ticket ID',
	inputMode = 'numeric',
	hasActiveFilters = true,
	marginTop = { base: '48px', lg: '0' },
	marginBottom = { base: '8px', lg: '12px' },
	onChangeValue,
	onKeyDown,
	onSearch,
	onClearSearch,
	onFilterClick,
	showSearchButtonWhenValue = false,
}) => {
	return (
		<Flex
			width='100%'
			alignItems='center'
			gap='8px'
			marginTop={marginTop}
			marginBottom={marginBottom}
		>
			<InputGroup flex='1'>
				<Input
					id='search-input'
					value={searchValue}
					onChange={onChangeValue}
					onKeyDown={onKeyDown}
					placeholder={placeholder}
					inputMode={inputMode}
					height={{ base: '40px', lg: '40px' }}
					paddingLeft='12px'
					paddingRight={searchValue && showSearchButtonWhenValue ? '84px' : '56px'}
					border={`1px solid ${RECORD_SURFACES.filterBorder}`}
					borderRadius='100px'
					background='#FFFFFFB2'
					color={RECORD_TEXT_COLORS.primary}
					fontSize='16px'
					fontWeight='400'
					_placeholder={{ color: RECORD_TEXT_COLORS.placeholder }}
					_focusVisible={{
						borderColor: 'transparent',
						boxShadow: 'none',
					}}
					_hover={{
						borderColor: 'transparent',
						boxShadow: 'none',
					}}
				/>
				<InputRightElement height='100%' width='auto' paddingRight='12px'>
					<Flex alignItems='center' gap='8px'>
						{searchValue && (
							<Flex
								as='button'
								type='button'
								width='20px'
								height='20px'
								alignItems='center'
								justifyContent='center'
								onClick={onClearSearch}
							>
								<ImgComp svgName='x-circle' height={5} width={5} />
							</Flex>
						)}
						<Box as='button' type='button' onClick={onSearch}>
							<SearchIcon color='#0A54EF' boxSize='16px' />
						</Box>
					</Flex>
				</InputRightElement>
			</InputGroup>

			<FilterTriggerButton hasActiveFilters={hasActiveFilters} onFilterClick={onFilterClick} />
		</Flex>
	);
};
export default SearchFilterHeader;

export const FilterTriggerButton = ({ hasActiveFilters = true, onFilterClick }) => {
	return (
		<Flex
			as='button'
			type='button'
			width='40px'
			height='40px'
			alignItems='center'
			justifyContent='center'
			borderRadius='8px'
			background={hasActiveFilters ? RECORD_GRADIENTS.filterActive : '#FFFFFF'}
			border={hasActiveFilters ? '1px solid #F5C34B' : `1px solid ${RECORD_SURFACES.filterBorder}`}
			boxShadow={hasActiveFilters ? RECORD_SHADOWS.filterActive : 'none'}
			onClick={onFilterClick}
		>
			<Flex
				direction='column'
				gap='3px'
				alignItems='center'
				justifyContent='center'
				aria-hidden='true'
			>
				<ImgComp svgName='filter-line' height={9} width={4} />
			</Flex>
		</Flex>
	);
};
